import { Postrequestcall } from "./request/Postrequest";
import { UPDATE_NOTIFICATION_STATUS } from "./constant/Apipath";
import store from "./redux/store/store";

export const notificationApi = async (msgId, loginData) => {
  if (!msgId || Number(msgId) === 0) {
    return;
  }
  const currentLoginData = store.getState()?.main?.loginData || loginData;
  if (!currentLoginData?.accessToken) {
    console.warn("notificationApi: No access token available in loginData or Redux store");
    return;
  }
  const obj = {
    NotificationMessageId: msgId,
    ReceiverUserDevice: currentLoginData?.userInformation?.DeviceId || "",
  };
  const res = await Postrequestcall(UPDATE_NOTIFICATION_STATUS, obj, currentLoginData?.accessToken);
  return res;
};
